export function getReadableDate(date){
    if(!date || date == "") return;
    
    let dateAsArray = date.split("-");

    if(dateAsArray.length != 3) return date;

    return (dateAsArray[2].length == 1 ? ("0" + dateAsArray[2]) : dateAsArray[2]) + "." + (dateAsArray[1].length == 1 ? ("0" + dateAsArray[1]) : dateAsArray[1]) + "." + dateAsArray[0];
}